module.exports = __webpack_public_path__ + "img/xml_icon.f70e321c.svg";